import React from 'react';
import translate from '../../../utils/translate';

// This is the seat map color coded legend
export default class SeatmapLegend extends React.Component {
  render () {
    return (
      <div className="seatmaplegend" data-component="seatmap-legend">
        <ul className="seatmaplegend__ul">
          <li className="seatmaplegend__li" data-component="seatmap-legend-filter-match">
            <div className="seatmaplegend__text">{translate('ismModule', 'AVAILABLE_FILTER_MATCH')}</div>
          </li>
          <li className="seatmaplegend__li" data-component="seatmap-legend-available">
            <div className="seatmaplegend__text">{translate('ismModule', 'ALSO_AVAILABLE')}</div>
          </li>
          <li className="seatmaplegend__li" data-component="seatmap-legend-not-available">
            <div className="seatmaplegend__text">{translate('ismModule', 'NOT_AVAILABLE')}</div>
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/legend/index.js